"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Transaction = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@codametrix/ui-components");
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var lookup_1 = require("../../code-bench-panel/lookup/lookup");
var can_drop_1 = require("./can-drop");
var show_results_1 = require("./show-results");
var transaction_charge_utils_1 = require("./transaction-charge.utils");
var invoice_meta_info_1 = require("../../code-bench-panel/invoice-meta/invoice-meta-info");
var error_submission_1 = __importDefault(require("../../code-bench-panel/error-submission"));
var svg_icons_1 = __importDefault(require("../../svgs/svg-icons"));
var time_based_code_popover_1 = __importDefault(require("./time-based-code-popover"));
var react_2 = require("@chakra-ui/react");
var transaction_accordion_1 = require("./transaction-accordion");
var theme_1 = __importDefault(require("../../../theme"));
var ChargeSessionCodeProvenance = ui_common_1.commonEnums.ChargeSessionCodeProvenance;
var draggedCodesManager = ui_common_1.dragManager.load('codes');
var sharedCodePredicate = function (code) {
    //@ts-ignore
    return code.shared === true;
};
var notSharedCodePredicate = function (code) {
    //@ts-ignore
    return !(code.shared === true);
};
/**
 * Method that get data from codable object
 * @param element
 * @param codable
 * @returns
 */
var getDataItem = function (element, codable) {
    var _a;
    var parent = element.closest('.transaction-header');
    if (parent) {
        var codeId_1 = parent.attributes.getNamedItem('data-code');
        var codeType_1 = parent.attributes.getNamedItem('data-code-type');
        if (codeId_1 && codeType_1) {
            return ((_a = codable.codes.find(function (code) {
                return (ui_common_1.cmxTypeguards.isChargeSessionCode(code) &&
                    "".concat(code.code) === "".concat(codeId_1.value) &&
                    code.codeType === "".concat(codeType_1.value));
            })) !== null && _a !== void 0 ? _a : null);
        }
    }
    return null;
};
/**
 * Class React component for render a transaction
 */
var Transaction = /** @class */ (function (_super) {
    __extends(Transaction, _super);
    function Transaction(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Manage onBlur event for valid units
         * @param ev
         */
        _this.handleBlurEvent = function (ev) {
            ev.stopPropagation();
            if (_this.props.editable) {
                var element = ev.target;
                var codeUnitsInput = element === null || element === void 0 ? void 0 : element.closest('.code-units-input');
                if (codeUnitsInput && _this.currentUnit) {
                    codeUnitsInput.value = _this.currentUnit.toString();
                }
            }
        };
        _this.isTimeBasedCode = function () {
            var _a, _b;
            return (_b = (_a = _this.props.codableTransaction) === null || _a === void 0 ? void 0 : _a.procedure) === null || _b === void 0 ? void 0 : _b.time_based;
        };
        _this.handleTimeBasedCodeAdd = function (ev, time, age) {
            ev.preventDefault();
            ev.stopPropagation();
            var _a = _this.props, chargeSession = _a.chargeSession, codableTransaction = _a.codableTransaction;
            var element = ev.target;
            var dataItem = getDataItem(element, codableTransaction || chargeSession);
            var changeDetail = {
                codes: [dataItem],
                context: {
                    chargeSession: __assign({}, _this.props.chargeSession),
                    transaction: __assign({}, _this.props.codableTransaction),
                    invoice: __assign({}, _this.props.invoice),
                    processInstance: __assign({}, _this.props.processInstance)
                }
            };
            _this.props.handleTimeBasedCodeAdd(changeDetail, time, age);
            if (_this.lookupRef.current) {
                _this.lookupRef.current.focus();
            }
        };
        _this.handleTimeBasedCodeUpdate = function (ev, time, age) {
            ev.preventDefault();
            ev.stopPropagation();
            var _a = _this.props, chargeSession = _a.chargeSession, codableTransaction = _a.codableTransaction;
            var element = ev.target;
            var dataItem = getDataItem(element, codableTransaction || chargeSession);
            var changeDetail = {
                codes: [dataItem],
                context: {
                    chargeSession: __assign({}, _this.props.chargeSession),
                    transaction: __assign({}, _this.props.codableTransaction),
                    invoice: __assign({}, _this.props.invoice),
                    processInstance: __assign({}, _this.props.processInstance)
                }
            };
            _this.props.handleTimeBasedCodeUpdate(changeDetail, time, age);
            if (_this.lookupRef.current) {
                _this.lookupRef.current.focus();
            }
        };
        _this.isClockIconDisabled = function () {
            var _a, _b;
            var procedure = (_a = _this.props.codableTransaction) === null || _a === void 0 ? void 0 : _a.procedure;
            var invoice = _this.props.invoice;
            return (procedure &&
                ((_b = invoice === null || invoice === void 0 ? void 0 : invoice.transactions) === null || _b === void 0 ? void 0 : _b.some(function (transaction) {
                    var _a;
                    return ((_a = transaction === null || transaction === void 0 ? void 0 : transaction.procedure) === null || _a === void 0 ? void 0 : _a.add_on_code_id) ===
                        (procedure === null || procedure === void 0 ? void 0 : procedure.additionalProperties['id']);
                })));
        };
        //handle this manually so we can unmount it
        _this.handlePopoverClose = function (newState) {
            _this.setState({ clickTriggered: newState });
        };
        _this.timeBasedCodePopup = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            var popoverState = _this.state.clickTriggered;
            var handlePopoverOpen = function (ev) {
                // Prevents the default behavior of the click event
                ev.stopPropagation();
                // Toggle the state when the user clicks to open the popover manually
                _this.setState({ clickTriggered: !_this.state.clickTriggered });
            };
            return ((0, jsx_runtime_1.jsx)(react_2.ChakraProvider, __assign({ theme: theme_1["default"] }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: ((_b = (_a = _this.props.codableTransaction) === null || _a === void 0 ? void 0 : _a.procedure) === null || _b === void 0 ? void 0 : _b.time_based) &&
                        ((_d = (_c = _this.props.codableTransaction) === null || _c === void 0 ? void 0 : _c.procedure) === null || _d === void 0 ? void 0 : _d.total_time)
                        ? 'clock-time-section'
                        : 'clock-section' }, { children: (0, jsx_runtime_1.jsxs)(react_2.Popover, __assign({ isOpen: popoverState, placement: "bottom-end", variant: "time" }, { children: [(0, jsx_runtime_1.jsx)(react_2.PopoverTrigger, { children: (0, jsx_runtime_1.jsxs)(react_2.Button, __assign({ ref: _this.iconRef, "aria-label": "", size: "xs", variant: "clockv1", disabled: !_this.props.editable || _this.isClockIconDisabled(), onClick: handlePopoverOpen }, { children: [(0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "BiomeClock", svgIconSize: "20", svgIconClass: ((_f = (_e = _this.props.codableTransaction) === null || _e === void 0 ? void 0 : _e.procedure) === null || _f === void 0 ? void 0 : _f.time_based) &&
                                                ((_h = (_g = _this.props.codableTransaction) === null || _g === void 0 ? void 0 : _g.procedure) === null || _h === void 0 ? void 0 : _h.total_time)
                                                ? 'grey-clock'
                                                : 'color-clock' }), ((_k = (_j = _this.props.codableTransaction) === null || _j === void 0 ? void 0 : _j.procedure) === null || _k === void 0 ? void 0 : _k.time_based) &&
                                            ((_m = (_l = _this.props.codableTransaction) === null || _l === void 0 ? void 0 : _l.procedure) === null || _m === void 0 ? void 0 : _m.total_time) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "total-time" }, { children: _this.props.codableTransaction.procedure.total_time })))] })) }), (0, jsx_runtime_1.jsx)(react_2.Portal, { children: popoverState && ((0, jsx_runtime_1.jsx)(react_2.PopoverContent, { children: (0, jsx_runtime_1.jsx)(react_2.PopoverBody, { children: (0, jsx_runtime_1.jsx)(time_based_code_popover_1["default"], { codableTransaction: _this.props.codableTransaction, handleTimeBasedCodeAdd: _this.handleTimeBasedCodeAdd, handleTimeBasedCodeUpdate: _this.handleTimeBasedCodeUpdate, processInstance: _this.props.processInstance, popoverState: popoverState, updatePopoverState: _this.handlePopoverClose }) }) })) })] })) })) })));
        };
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.handleUnitsClick = _this.handleUnitsClick.bind(_this);
        _this.handleCodeDelete = _this.handleCodeDelete.bind(_this);
        _this.onSearch = _this.onSearch.bind(_this);
        _this.onSearchSelection = _this.onSearchSelection.bind(_this);
        _this.onDropHandler = _this.onDropHandler.bind(_this);
        _this.onDragOver = _this.onDragOver.bind(_this);
        _this.onDrop = _this.onDrop.bind(_this);
        _this.onDragLeave = _this.onDragLeave.bind(_this);
        _this.onDelete = _this.onDelete.bind(_this);
        _this.onAccordionAction = _this.onAccordionAction.bind(_this);
        _this.handleCodeChecked = _this.handleCodeChecked.bind(_this);
        _this.handleEnableTechPro = _this.handleEnableTechPro.bind(_this);
        _this.handleDisableTechPro = _this.handleDisableTechPro.bind(_this);
        _this.isTimeBasedCode = _this.isTimeBasedCode.bind(_this);
        _this.timeBasedCodePopup = _this.timeBasedCodePopup.bind(_this);
        _this.lookupRef = react_1["default"].createRef();
        _this.iconRef = react_1["default"].createRef();
        _this.state = { dragHover: false, clickTriggered: false };
        return _this;
    }
    // logic to show the timebased popover after page load
    Transaction.prototype.componentDidUpdate = function (prevProps) {
        var _a, _b;
        var prevProcedure = (_a = prevProps.codableTransaction) === null || _a === void 0 ? void 0 : _a.procedure;
        var newProcedure = (_b = this.props.codableTransaction) === null || _b === void 0 ? void 0 : _b.procedure;
        if ((prevProcedure === null || prevProcedure === void 0 ? void 0 : prevProcedure.procedure_code) !== (newProcedure === null || newProcedure === void 0 ? void 0 : newProcedure.procedure_code)) {
            this.setState({ clickTriggered: false });
        }
        // This code opens the popover if the time code is required.
        // BSP customer asked for that to not be the default, but product wants it to be a configurable option.
        // Keeping this code so we can use it when we make it configurable.
        /* if (newProcedure) {
          if (
            newProcedure?.time_based &&
            newProcedure?.add_on_code_available &&
            !newProcedure.total_time &&
            !this.state.clickTriggered
          ) {
            this.iconRef.current.click();
            this.setState({ clickTriggered: true });
          }
        } */
    };
    /**
     * Event for drag over
     * @param ev
     */
    Transaction.prototype.onDragOver = function (ev) {
        var data = draggedCodesManager.get();
        var searchResult = ui_common_1.cmxTypeguards.isSearchResult(data);
        if (searchResult) {
            var _a = this.props, codableTransaction = _a.codableTransaction, chargeSession = _a.chargeSession;
            var hasCPT = (codableTransaction || chargeSession).codes
                .filter(ui_common_1.cmxTypeguards.isChargeSessionCode)
                .some(function (sessionCode) {
                return (sessionCode.provenance.toUpperCase() ===
                    ChargeSessionCodeProvenance.CPT.toUpperCase());
            });
            var allowed = data.codeType.toUpperCase() === ChargeSessionCodeProvenance.CPT
                ? !hasCPT
                : true;
            if (allowed) {
                ev.dataTransfer.dropEffect = 'copy';
                ev.preventDefault();
                if (!this.state.dragHover) {
                    this.setState({ dragHover: true });
                }
            }
        }
    };
    /**
     * Event for drag leaves
     * @param ev
     */
    Transaction.prototype.onDragLeave = function (ev) {
        if (this.state.dragHover) {
            this.setState({ dragHover: false });
        }
        ev.dataTransfer.dropEffect = 'none';
    };
    /**
     * Event for drag drops
     * @param ev
     */
    Transaction.prototype.onDrop = function (ev) {
        var searchResult = draggedCodesManager.parseEvent(ev);
        draggedCodesManager.clear();
        var codableTransaction = this.props.codableTransaction;
        if (codableTransaction) {
            var codes = codableTransaction.codes
                .filter(ui_common_1.cmxTypeguards.isChargeSessionCode)
                .filter(function (sessionCode) {
                return (sessionCode.codeType.toUpperCase() ===
                    searchResult.codeType.toUpperCase());
            });
            var result = __assign(__assign({}, searchResult), { context: {
                    invoice: __assign({}, this.props.invoice),
                    transaction: __assign({}, this.props.codableTransaction),
                    chargeSession: __assign({}, this.props.chargeSession),
                    processInstance: __assign({}, this.props.processInstance)
                } });
            codes.push(result);
            this.props.onCodeSearchSelection(__assign(__assign({}, searchResult), { context: {
                    chargeSession: __assign({}, this.props.chargeSession)
                } }));
            this.setState({ dragHover: false });
            if (this.lookupRef.current) {
                this.lookupRef.current.reset();
                this.lookupRef.current.focus();
            }
        }
    };
    /**
     * Event for handle drag drop
     * @param ev
     */
    Transaction.prototype.onDropHandler = function (dropAction) {
        var _a = this.props, chargeSession = _a.chargeSession, codableTransaction = _a.codableTransaction;
        var dropCandidate = dropAction.dropCandidate, dropTarget = dropAction.dropTarget;
        var sameCodeType = "".concat(dropCandidate.codeType).toUpperCase() ===
            "".concat(dropTarget.codeType).toUpperCase();
        var matchCodes = function (sessionCode) {
            var matchType = "".concat(sessionCode.codeType).toUpperCase() ===
                "".concat(dropCandidate.codeType).toUpperCase();
            var matchProvenance = "".concat(sessionCode.provenance).toUpperCase() ===
                "".concat(dropCandidate.codeType).toUpperCase();
            if (matchProvenance || matchType) {
                return sessionCode.code !== dropCandidate.code;
            }
            return false;
        };
        // remove the code from our code list
        var codes = (codableTransaction || chargeSession).codes
            .filter(matchCodes)
            .filter(ui_common_1.cmxTypeguards.isChargeSessionCode);
        var searchResult = ui_common_1.cmxTypeguards.isSearchResult(dropCandidate);
        var dropCode = dropCandidate;
        if (searchResult) {
            dropCode = {
                code: dropCandidate.code,
                codeType: dropCandidate.codeType,
                description: dropCandidate.description
            };
            var targetPosition = codes.findIndex(function (sessionCode) { return sessionCode.code === dropTarget.code; });
            if (dropAction.position === 'after') {
                targetPosition++;
            }
            codes.splice(targetPosition, 0, dropCode);
            if (this.lookupRef.current) {
                this.lookupRef.current.reset();
                this.lookupRef.current.focus();
            }
        }
        else {
            // if the codes are of the same code type
            // then a drop is just a reordering of the same codes
            // if a drop is on a different code type, then we need
            // to do something different.
            if (sameCodeType) {
                var targetCode_1 = dropTarget.code;
                if (ui_common_1.cmxTypeguards.isZippedCodeBlock(dropCode)) {
                    var blockSet_1 = new Set(dropCode.codes.map(function (code) { return code.code; }));
                    var filteredArray = __spreadArray([], __read(codes), false).filter(function (code) { return !blockSet_1.has(code.code); });
                    var seekPosition = filteredArray.findIndex(function (sessionCode) { return sessionCode.code === dropTarget.code; });
                    if (dropAction.position === 'after') {
                        seekPosition++;
                    }
                    filteredArray.splice.apply(filteredArray, __spreadArray([seekPosition, 0], __read(dropCode.codes), false));
                    codes = filteredArray;
                    // capturing the drag complete for Datadog Action
                    // @ts-ignore
                    window.DD_RUM.addAction('Drag (shared row moved)', {});
                }
                else {
                    // if this is a shared code block then we need to rewind to the
                    // front of the shared codes
                    var codeIncrement = 1;
                    if (ui_common_1.cmxTypeguards.isZippedCodeBlock(dropTarget)) {
                        var _b = __read(dropTarget.codes, 1), firstCode = _b[0];
                        targetCode_1 = firstCode.code;
                        codeIncrement = dropTarget.codes.length;
                    }
                    var targetPosition = codes.findIndex(function (sessionCode) { return sessionCode.code === targetCode_1; });
                    if (dropAction.position === 'after') {
                        targetPosition += codeIncrement;
                    }
                    codes.splice(targetPosition, 0, dropCandidate);
                }
                // capturing the drag complete for Datadog Action
                // @ts-ignore
                window.DD_RUM.addAction('Drag (any code row moved)', {});
            }
            else {
                if (ui_common_1.cmxTypeguards.isZippedCodeBlock(dropCandidate)) {
                    var blockSet_2 = new Set(dropCandidate.codes.map(function (code) { return code.code; }));
                    var filteredArray = __spreadArray([], __read(codes), false).filter(function (code) { return !blockSet_2.has(code.code); });
                    var seekPosition = filteredArray.findIndex(function (sessionCode) { return sessionCode.code === dropTarget.code; });
                    if (dropAction.position === 'after') {
                        seekPosition++;
                    }
                    filteredArray.splice.apply(filteredArray, __spreadArray([seekPosition, 0], __read(dropCandidate.codes), false));
                    codes = filteredArray;
                    // capturing the drag complete for Datadog Action
                    // @ts-ignore
                    window.DD_RUM.addAction('Drag (shared row moved to top)', {});
                }
                else {
                    // there is a defined visual order of codes
                    // PROCEDURES, MODIFIERS, DX
                    // if this changes, then the order will need to be updated
                    var dropIndex = can_drop_1.CODE_ORDER.get("".concat(dropCandidate.codeType));
                    var dropTargetIndex = can_drop_1.CODE_ORDER.get("".concat(dropTarget.codeType));
                    if (dropIndex < dropTargetIndex) {
                        codes.push(dropCandidate);
                    }
                    else {
                        codes.unshift(dropCandidate);
                    }
                    // capturing the drag complete for Datadog Action
                    // @ts-ignore
                    window.DD_RUM.addAction('Drag (invoice code row move to top)', {});
                }
            }
        }
        var changeDetail = {
            codes: codes,
            context: {
                chargeSession: __assign({}, this.props.chargeSession),
                invoice: __assign({}, this.props.invoice),
                transaction: __assign({}, this.props.codableTransaction),
                processInstance: __assign({}, this.props.processInstance)
            }
        };
        this.props.handleCodeSearchDrop(changeDetail);
        this.setState({ dragHover: false });
    };
    /**
     * Event launched when a search is performed
     * @param ev
     */
    Transaction.prototype.onSearch = function (codeQuery) {
        this.props.onCodeSearch(__assign(__assign({}, codeQuery), { context: {
                transaction: __assign({}, this.props.codableTransaction),
                invoice: __assign({}, this.props.invoice),
                chargeSession: __assign({}, this.props.chargeSession),
                processInstance: __assign({}, this.props.processInstance)
            } }));
    };
    /**
     * Event launched when a search selection is pressed
     * @param ev
     */
    Transaction.prototype.onSearchSelection = function (searchResult) {
        // check to see if the code is already in the charge session
        var present = this.props.codableTransaction.codes
            .filter(ui_common_1.cmxTypeguards.isChargeSessionCode)
            .findIndex(function (sessionCode) {
            return (sessionCode.code === searchResult.code &&
                sessionCode.provenance === searchResult.codeType);
        });
        var searchSelection = __assign(__assign({}, searchResult), { context: {
                defaultPrevented: present !== -1,
                invoice: __assign({}, this.props.invoice),
                transaction: __assign({}, this.props.codableTransaction),
                chargeSession: __assign({}, this.props.chargeSession),
                processInstance: __assign({}, this.props.processInstance)
            } });
        this.props.onCodeSearchSelection(searchSelection);
    };
    /**
     * Event launched when units input is clicked
     * @param ev
     */
    Transaction.prototype.handleUnitsClick = function (ev) {
        ev.stopPropagation();
        if (this.props.editable) {
            var element = ev.target;
            if (element instanceof HTMLInputElement && element.type === 'text') {
                element.select();
            }
        }
    };
    /**
     * Event launched when a code is deleted
     * @param ev
     */
    Transaction.prototype.handleCodeDelete = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (this.props.editable) {
            var _a = this.props, chargeSession = _a.chargeSession, codableTransaction = _a.codableTransaction;
            var element = ev.target;
            var dataItem = getDataItem(element, codableTransaction || chargeSession);
            var changeDetail = {
                codes: [dataItem],
                context: {
                    chargeSession: __assign({}, this.props.chargeSession),
                    transaction: __assign({}, this.props.codableTransaction),
                    invoice: __assign({}, this.props.invoice),
                    processInstance: __assign({}, this.props.processInstance)
                }
            };
            this.props.handleCodeRemove(changeDetail);
            if (this.lookupRef.current) {
                this.lookupRef.current.focus();
            }
        }
    };
    /**
     * Event launched when a shared code is toggled.
     * @param ev
     */
    Transaction.prototype.handleCodeChecked = function (ev) {
        ev.stopPropagation();
        var codableTransaction = this.props.codableTransaction;
        var action = ev.target.checked ? 'ADD' : 'REMOVE';
        var diagnoses = [];
        if (action === 'REMOVE') {
            diagnoses = [
                {
                    diagnosis_code: ev.target.name,
                    shared: true
                }
            ];
        }
        else if (action === 'ADD') {
            var codes = this.props.codableTransaction.codes
                .filter(ui_common_1.cmxTypeguards.isChargeSessionCode)
                .filter(function (code) { return code.codeType === 'diagnosis'; });
            diagnoses = codes.map(function (code, idx) {
                return {
                    diagnosis_code: code.code,
                    sequence_number: idx + 1,
                    //@ts-ignore
                    shared: code.shared,
                    //@ts-ignore
                    active: code.code === ev.target.name ? true : code.active
                };
            });
        }
        var payload = {
            action: action,
            codeUpdate: {
                transactionGuid: codableTransaction.guid,
                processInstance: this.props.processInstance,
                serviceLine: this.props.processInstance.serviceLine,
                diagnoses: diagnoses
            }
        };
        this.props.onTransactionSharedDiagnosisChange(payload);
    };
    /**
     * Event launched when a key is pressed on input tag
     * @param ev
     */
    Transaction.prototype.handleKeyPress = function (ev) {
        ev.stopPropagation();
        if (this.props.editable) {
            var codableTransaction = this.props.codableTransaction;
            var element = ev.target;
            var codeUnitsInput = element === null || element === void 0 ? void 0 : element.closest('.code-units-input');
            var dataItem = getDataItem(element, codableTransaction);
            if (codeUnitsInput && (0, transaction_charge_utils_1.isAValidUnits)(codeUnitsInput.value)) {
                this.currentUnit = (0, transaction_charge_utils_1.parseUnits)(parseInt(codeUnitsInput.value));
                var code = __assign(__assign({}, dataItem), { units: this.currentUnit });
                var changeDetail = {
                    codes: [code],
                    context: {
                        chargeSession: __assign({}, this.props.chargeSession),
                        transaction: __assign({}, this.props.codableTransaction),
                        invoice: __assign({}, this.props.invoice),
                        processInstance: __assign({}, this.props.processInstance)
                    }
                };
                this.props.handleCodeChange(changeDetail);
            }
            else {
                this.currentUnit = (dataItem === null || dataItem === void 0 ? void 0 : dataItem.units) ? Number(dataItem === null || dataItem === void 0 ? void 0 : dataItem.units) : null;
            }
        }
    };
    /**
     * Event launched when a transaction is deleted
     * @param event
     */
    Transaction.prototype.onDelete = function (event) {
        event.preventDefault();
        this.props.onChargeSessionAction({
            action: 'DELETE_TRANSACTION',
            chargeSession: this.props.chargeSession,
            meta: {
                invoice: this.props.invoice,
                transaction: __assign({}, this.props.codableTransaction)
            }
        });
    };
    /**
     * Event launched by the accordion
     * @param action
     * @param item
     */
    Transaction.prototype.onAccordionAction = function (action, item) {
        var chargeSessionCode = item.data;
        var opening = action === ui_components_1.AccordionSectionAction.OPEN;
        var selection = {
            chargeSessionCode: chargeSessionCode,
            evidence: chargeSessionCode.evidence,
            selectionState: {
                active: false,
                hover: false,
                visible: opening
            }
        };
        this.props.onFeatureSelection(selection);
    };
    /**
     * Method used for enable a procedure with tech/pro charge
     * @param techTransactionCodable
     */
    Transaction.prototype.handleEnableTechPro = function (techTransactionCodable) {
        if (this.props.editable) {
            techTransactionCodable.invoice = this.props.invoice;
            this.props.handleEnableTechPro(techTransactionCodable);
        }
    };
    /**
     * Method used for disable a procedure with tech/pro charge
     * @param techTransactionCodable
     */
    Transaction.prototype.handleDisableTechPro = function (techTransactionCodable) {
        if (this.props.editable) {
            techTransactionCodable.invoice = this.props.invoice;
            this.props.handleDisableTechPro(techTransactionCodable);
        }
    };
    Transaction.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var _h = this.props, chargeSession = _h.chargeSession, codableTransaction = _h.codableTransaction, lineNumber = _h.lineNumber, editable = _h.editable, invoice = _h.invoice, onCodeSearch = _h.onCodeSearch, handleCodeChange = _h.handleCodeChange, handleCodeSearchDrop = _h.handleCodeSearchDrop, handleCodeRemove = _h.handleCodeRemove, canDropOnto = _h.canDropOnto, searchResults = _h.searchResults, onCodeSearchSelection = _h.onCodeSearchSelection, onFeatureSelection = _h.onFeatureSelection, onChargeSessionAction = _h.onChargeSessionAction, onEdit = _h.onEdit, autoFocus = _h.autoFocus, panelActivations = _h.panelActivations, processInstance = _h.processInstance, transaction = _h.transaction, debounceTimeout = _h.debounceTimeout, codeEdits = _h.codeEdits, onTransactionSharedDiagnosisChange = _h.onTransactionSharedDiagnosisChange, rest = __rest(_h, ["chargeSession", "codableTransaction", "lineNumber", "editable", "invoice", "onCodeSearch", "handleCodeChange", "handleCodeSearchDrop", "handleCodeRemove", "canDropOnto", "searchResults", "onCodeSearchSelection", "onFeatureSelection", "onChargeSessionAction", "onEdit", "autoFocus", "panelActivations", "processInstance", "transaction", "debounceTimeout", "codeEdits", "onTransactionSharedDiagnosisChange"]);
        var txnType = (_a = transaction === null || transaction === void 0 ? void 0 : transaction.type) !== null && _a !== void 0 ? _a : 'unknown txn type';
        var styleClasses = [
            'charge-session-information',
            "charge-session-".concat(txnType.toLowerCase()),
            {
                'charge-session-editable': editable,
                'charge-session-uneditable': !editable,
                'charge-session-drop-zone': this.state.dragHover
            }
        ];
        var boundAccordionBuilder = transaction_accordion_1.transactionAccordianBuilder.bind(null, this.handleKeyPress, this.handleBlurEvent, this.handleUnitsClick, this.handleCodeDelete, this.handleCodeChecked, this.handleDisableTechPro, this.handleEnableTechPro, onFeatureSelection, this.isTimeBasedCode, this.timeBasedCodePopup, panelActivations, invoice, codeEdits);
        var assuranceErrorMessage = ((_b = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _b === void 0 ? void 0 : _b.errorMessages)
            ? (_c = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _c === void 0 ? void 0 : _c.errorMessages
            : [];
        // removing procedures with provenance TECH
        if (codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.hasOwnProperty('codes')) {
            codableTransaction.codes = codableTransaction.codes
                .filter(ui_common_1.cmxTypeguards.isChargeSessionCode)
                .filter(function (code) { return !(code.codeType === 'procedure' && code.provenance === 'TECH'); });
        }
        var sharedCodes = (invoice === null || invoice === void 0 ? void 0 : invoice.type) === ui_common_1.commonEnums.InvoiceTypes.SHARED_CODES;
        var boundAccordionBuilderHandler = function (code, index) {
            return boundAccordionBuilder(code, index, codableTransaction, assuranceErrorMessage);
        };
        var items = [];
        var chargeMeta = false;
        if (codableTransaction) {
            var codes = JSON.parse(JSON.stringify((_d = codableTransaction.codes) !== null && _d !== void 0 ? _d : []));
            if (!sharedCodes) {
                var onlyShared = codes.filter(sharedCodePredicate);
                var firstIndex = codes.findIndex(sharedCodePredicate);
                var lastIndex = codes.findIndex(notSharedCodePredicate, firstIndex);
                var preArray = codes.slice(0, firstIndex);
                var postArray = codes.slice(firstIndex + onlyShared.length);
                var zippedShareCodes = {
                    codes: onlyShared,
                    codeType: ui_common_1.commonEnums.CodeType.DIAGNOSIS,
                    zipped: true
                };
                codes = __spreadArray(__spreadArray(__spreadArray([], __read(preArray), false), [zippedShareCodes], false), __read(postArray), false);
            }
            var filtered = codes.filter(function (code) {
                return ui_common_1.cmxTypeguards.isChargeSessionCode(code) ||
                    (ui_common_1.cmxTypeguards.isZippedCodeBlock(code) && code.codes.length);
            });
            items = filtered.map(boundAccordionBuilderHandler);
            // TODO: Determine code types
            chargeMeta =
                (invoice === null || invoice === void 0 ? void 0 : invoice.type) !== ui_common_1.commonEnums.InvoiceTypes.SHARED_CODES ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "charge-line" }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: "charge-index" }, { children: ["Charge ", lineNumber, ":"] })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "charge-charge-type", style: { display: 'none' } }, { children: "SOME CODE TYPE:" })), editable ? ((0, jsx_runtime_1.jsx)("span", __assign({ className: "charge-delete-container" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "#/delete-session", onClick: this.onDelete }, { children: "remove" })) }))) : (false)] }))) : (false);
        }
        else if (chargeSession) {
            items = chargeSession.codes.map(boundAccordionBuilderHandler);
            // TODO: Determine code types
            chargeMeta = ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "charge-line" }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: "charge-index" }, { children: ["Charge ", lineNumber, ":"] })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "charge-charge-type", style: { display: 'none' } }, { children: "SOME CODE TYPE:" })), editable ? ((0, jsx_runtime_1.jsx)("span", __assign({ className: "charge-delete-container" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "#/delete-session", onClick: this.onDelete }, { children: "remove" })) }))) : (false)] })));
        }
        else if (transaction) {
            var diagnosis = [];
            var modifiers = [];
            // TODO:
            // const diagnosis = (invoice?.shared_codes.diagnoses ?? []).map(
            //   code => code.diagnosis_code
            // );
            // const modifiers = (invoice?.shared_codes.modifiers ?? []).map(
            //   code => code.modifier_code
            // );
            var dxString = diagnosis.length
                ? "diagnosis: ".concat(diagnosis.join(', '))
                : '';
            var modString = modifiers.length
                ? "modifiers: ".concat(modifiers.join(', '))
                : '';
            var conjunction = diagnosis.length && modifiers.length ? ' and ' : '';
            var alsoIncludes = "".concat(dxString, " ").concat(conjunction, " ").concat(modString);
            styleClasses.push({
                'show-also-includes': diagnosis.length || modifiers.length
            });
            var label = txnType in invoice_meta_info_1.CHARGE_TYPE_LABEL ? invoice_meta_info_1.CHARGE_TYPE_LABEL[txnType] : txnType;
            items = transaction.codes.map(boundAccordionBuilderHandler);
            chargeMeta = ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "transaction-meta transaction-".concat(txnType.toLowerCase()) }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: "ordinal" }, { children: [lineNumber, ". "] })), label, ' ', (0, jsx_runtime_1.jsxs)("span", __assign({ className: "also-includes" }, { children: ["Includes shared ", alsoIncludes] }))] })));
            styleClasses.push({
                'charge-session-has-description': !!transaction.description
            });
        }
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(styleClasses) }, { children: [chargeMeta, (0, jsx_runtime_1.jsx)(error_submission_1["default"], { errorMessages: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.errorMessages, messageStyle: "txn-error-message", messageType: "error" }), (0, jsx_runtime_1.jsx)(error_submission_1["default"], { errorMessages: (_e = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _e === void 0 ? void 0 : _e.errorMessages, messageStyle: "procedure-error-message", messageType: "error" }), items.length ? ((0, jsx_runtime_1.jsx)(ui_components_1.Accordion, { onAction: this.onAccordionAction, dragManager: draggedCodesManager, canDropOnto: canDropOnto, onDropHandler: this.onDropHandler, selectable: true, droppable: true, items: items, errors: (_g = (_f = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _f === void 0 ? void 0 : _f.errorMessages) !== null && _g !== void 0 ? _g : [] })) : editable ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "empty-message editable" }, { children: "Add codes using the search box below." }))) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "empty-message uneditable" }, { children: "No codes selected" }))), editable && codableTransaction && ((0, jsx_runtime_1.jsx)(lookup_1.Lookup, { ref: this.lookupRef, actionPrefix: "", placeholderText: (invoice === null || invoice === void 0 ? void 0 : invoice.type) === ui_common_1.commonEnums.InvoiceTypes.SHARED_CODES
                        ? 'Add shared diagnosis'
                        : 'Search for code', debounceTimeout: this.props.debounceTimeout, FieldDefinitions: codableTransaction.fieldDefinitions, shouldShowResults: show_results_1.shouldShowResults, autoFocus: autoFocus, onSearch: this.onSearch, onSearchSelection: this.onSearchSelection, searchResults: searchResults, searchResultsLookupKey: codableTransaction.guid, actionNameForDD: (invoice === null || invoice === void 0 ? void 0 : invoice.type) === ui_common_1.commonEnums.InvoiceTypes.SHARED_CODES
                        ? '~Focus code search (Shared)'
                        : '~Focus code search (General)' }))] })));
    };
    Transaction.displayName = 'Transaction';
    Transaction.defaultProps = {
        autoFocus: false,
        searchResults: [],
        editable: true,
        panelActivations: {},
        codeEdits: {},
        debounceTimeout: 200,
        canDropOnto: can_drop_1.canDropOnto,
        onChargeSessionAction: function (transactionAction) { },
        onTransactionSharedDiagnosisChange: function (changeDetail) { },
        handleCodeChange: function (change) { },
        handleCodeRemove: function (change) { },
        handleCodeSearchDrop: function (change) { },
        onCodeSearch: function (codeQuery) { },
        onCodeSearchSelection: function (searchSelection) { },
        onFeatureSelection: function (feature) { },
        onEdit: function (chargeSession) { },
        handleTimeBasedCodeAdd: function (change, time, age) { },
        handleTimeBasedCodeUpdate: function (change, time, age) { }
    };
    return Transaction;
}(react_1["default"].Component));
exports.Transaction = Transaction;
//# sourceMappingURL=transaction.js.map